import { renderApiDomain } from "../helper/renderApiDomain";
import { get } from "../helper/request";

export const getHolidayList = async () => {
  return get(`${renderApiDomain()}holiday`);
};
export const getHolidayNearby = async () => {
  return get(`${renderApiDomain()}holiday/nearby`);
};
